import axios from "axios";

export const config = {
  appUrl: "/",
  imageUrl: 'https://earth.cubextechnology.com/assets/front/img',
}

export const axiosInstance = axios.create({
  baseURL: "https://earth.cubextechnology.com/api/",

  headers: {
    "Content-Type": "application/json",
    'Access-Control-Allow-Origin': '*'
  },
});


